import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { FortnoxImportRun } from '../../models/FortnoxImportRun';

/** Imports a finished run's failed items again. */
export const useRetryFailedFortnoxImport = () => {
  const { callAPI } = useAPI<FortnoxImportRun>({ method: 'POST' });

  const action = async (runId: string): Promise<FortnoxImportRun> =>
    (await callAPI(buildApiUrl(`fortnoxImport/${runId}/retryFailed`))) as FortnoxImportRun;

  return { action };
};
